<!--
 * @Author: Daokai Huo
 * @Date: 2021-10-27 10:09:19
 * @LastEditTime: 2022-05-18 15:00:28
 * @Description: 组合组件
-->
<template>
  <ion-form :model="ruleForm" ref="combination" class="combination-wrap">
    <div class="combination-item" v-for="(item, index) in ruleForm.data" :key="index">
      <div
        v-if="!hideDelete"
        class="ion-icon-reduce"
        :class="ruleForm.data.length < 2 && 'icon-disabled'"
        @click="delBtn(index)"></div>
      <div class="combination-multiple">
        <ion-form-item
          v-for="(subItems, subIndex) in item.subItem"
          :prop="'data.' + index + '.subItem.' + subIndex + '.value'"
          :rules="subItems.rules"
          :key="subItems.subIndex">
          <component
            :is="subItems.comName"
            v-model="subItems.value"
            v-bind="subItems"
            @focus="handleFocus($event, subItems, index)">
            <template v-if="subItems.prepend" slot="prepend">
              {{ subItems.prepend }}
            </template>
            <template v-if="subItems.append" slot="append">{{ subItems.append }}</template>
          </component>
        </ion-form-item>
      </div>
    </div>
    <div class="add-btn" @click="addItem" v-if="max">
      <ion-icon name="add"></ion-icon>
      <span>{{ addText }}</span>
    </div>
  </ion-form>
</template>

<script>
  // import AsyncValidator from 'async-validator';
  import IonInput from '@/components/ui/input';
  import IonDropdown from '@/components/ui/dropdown';

  export default {
    name: 'IonCombinationItem',
    components: {
      IonInput,
      IonDropdown,
    },
    props: {
      // 是否必填
      required: Boolean,
      // 是否隐藏删除按钮
      hideDelete: {
        type: Boolean,
        default: false,
      },
      // 最大可添加数量
      maxlength: {
        type: Number,
        default: 30,
      },
      // 添加文字
      addText: {
        type: String,
        default: '添加车辆',
      },
      // 基础数据
      basicData: {
        type: Array,
        default: () => [],
      },
      data: Array,
      // 下拉框数据
      selectData: {
        type: Array,
        default: () => [],
      },
      // 输入内容是否唯一性校验
      inputOnly: {
        type: Boolean,
        default: false,
      },
      // 数量字段是否可编辑
      quantityEditable: {
        type: Boolean,
        default: true,
      },
      // data: {
      //   type: Array,
      //   default: () => [
      //     {
      //       carNumber: '这是用户卡号1',
      //       dp: '1',
      //     },
      //     {
      //       carNumber: '这是用户卡号2',
      //       dp: '1',
      //     },
      //   ],
      // },
    },
    data() {
      return {
        ruleForm: {
          data: [],
        },
        rules: [],
        dropdown: this.selectData,
      };
    },
    created() {
      this.setValue();
    },
    mounted() {},
    watch: {
      data: {
        handler(val) {
          if (val) this.setValue();
        },
        // 首次绑定是否执行handle
        immediate: false,
        // 是否深度监听
        deep: true,
      },
      // 下拉数据
      selectData: {
        handler(val) {
          this.dropdown = val;
        },
        // 首次绑定是否执行handle
        immediate: false,
        // 是否深度监听
        deep: true,
      },
    },
    computed: {
      // 支持最大行数
      max() {
        return this.maxlength > this.ruleForm.data.length;
      },
    },
    methods: {
      /**
       * 设置配置数据
       */
      setValue() {
        let result = [];
        const { data } = this;
        if (data && data.length) {
          result = data.map(item => this.initData(item));
        } else {
          result = [this.initData()];
        }
        this.ruleForm.data = result;
      },
      /**
       * 初始化一条配置数据
       */
      initData(val) {
        const { basicData } = this;
        // 保存校验规则
        this.rules = basicData.map(rule => rule.rules);
        // 拷贝数据
        const subItem = JSON.parse(JSON.stringify(basicData));
        // 添加自定义属性
        subItem.forEach((item, index) => {
          item.value = val ? val[item.key] : '';
          subItem[index].rules = this.rules[index];
          // 赋值下拉数据
          if (item.comName === 'IonDropdown' && this.selectData.length) {
            item.data = this.dropdown;
            console.log('subItem 初始化啥0', item.data);
          }
          // 控制数量字段是否可编辑
          if (
            !this.quantityEditable &&
            (item.key === 'issueCount' || item.key === 'count' || item.key === 'quantity')
          ) {
            item.disabled = true;
            item.readonly = true;
            // 设置默认值为1
            if (!item.value) {
              item.value = '1';
            }
          }
        });
        console.log('subItem 初始化啥', subItem);
        return { subItem };
      },

      /**
       * 删除操作
       */
      delBtn(index) {
        const { length } = this.ruleForm.data;
        if (length < 2) {
          return;
        }
        this.ruleForm.data.splice(index, 1);
        this.$emit('delBtn', index);
      },
      /**
       * 判断数组对象中的某个属性值是否重复
       * @param {Array} array - 要检查的数组
       * @param {String} key - 要检查的属性名
       * @returns {Boolean} - 如果有重复值返回true，否则返回false
       */
      isDuplicate(array, key) {
        const values = array.map(item => item[key]);
        const uniqueValues = new Set(values);
        return values.length !== uniqueValues.size;
      },
      /**
       * 添加操作
       */
      async addItem() {
        const result = await this.checkForm();
        console.log(result, '+++++++');
        if (result) {
          // 检查是否重复
          const dealData = this.dealResult();
          if (this.checkOnly(dealData)) {
            this.ruleForm.data.push(this.initData());
          }
        }
      },
      /**
       * 获取最终数据
       */
      getResult() {
        let validState = true;
        return this.checkForm().then(checkState => {
          const dealData = this.dealResult();
          if (!this.required) {
            const { length } = this.ruleForm.data;
            // 存在数据需要校验是否合法
            const state = dealData.some(item => Object.values(item)[0]);
            if (state || length > 1) {
              validState = checkState;
            } else {
              this.$refs.combination.clearValidate();
            }
          } else {
            validState = checkState;
          }
          if (!this.checkOnly(dealData)) {
            validState = false;
          }
          return Promise.resolve({ data: validState ? dealData : [], validState });
        });
      },
      /**
       * form校验
       */
      checkForm() {
        let check = true;
        return new Promise(resolve => {
          this.$refs.combination.validate(valid => {
            if (!valid) {
              check = false;
            }
            resolve(check);
          });
        });
      },
      // 唯一性校验
      checkOnly(data) {
        const keyName = Object.keys(data[0])[0]; // 取到键名
        if (this.inputOnly && this.isDuplicate(data, keyName)) {
          this.$message.error(`${this.addText}不能重复`);
          return false;
        }
        return true;
      },
      /**
       * 数据转换
       */
      dealResult() {
        const { data } = this.ruleForm;
        const arr = [];
        data.forEach((item, index) => {
          arr[index] = {};
          item.subItem.forEach(sub => {
            if (sub.value) {
              arr[index][sub.key || 'value'] = sub.value;
            }
          });
        });
        return Object.keys(arr[0]).length ? arr : [];
      },
      /**
       * 获取焦点的时候校验
       */
      handleFocus(v, row, rowIndex) {
        if (row.comName === 'IonDropdown') {
          if (row.only) {
            const resultData = this.dealResult();
            const selectIds = [];
            const { data } = this.ruleForm;
            console.log('data', data);
            // 已选择的优惠券（排除当前行）
            resultData.forEach((item, index) => {
              if (index !== rowIndex) {
                selectIds.push(item.couponId);
              }
            });
            data.forEach((item, k) => {
              const ite = item.subItem.filter(o => o.comName === 'IonDropdown')[0];
              // 过滤已选择的优惠券
              if (k === rowIndex) {
                console.log('过滤已经', rowIndex);
                ite.data = this.dropdown.filter(obj => !selectIds.includes(obj.id));
                console.log('过滤已经22', data);
              }
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  @import './index.scss';
</style>
